<template>
  <div class="content content--center">
    <h1>Куда планируете поступать?</h1>

    <div class="robot">
      <ul class="join join--grouped-col join--col">
        <router-link
          v-for="(kind, index) in KINDS"
          :key="kind.value"
          :to="{ name: 'abiturient.form.new', query: { kind: kind.value } }"
          @mouseenter="robotRef.lookAtButton(index + 1)"
          @mouseleave="robotRef.resetEyes()"
          class="join__item card card--lg card--active"
        >
          <div class="card__header">
            <p class="card__title">{{ kind.text }}</p>
            <img class="card__icon icon" src="@images/arrow.svg" v-svg-inline/>
          </div>
        </router-link>
      </ul>

      <robot ref="robotRef" class="robot__img" />
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { KINDS } from '@shared/config'
import Robot from './Robot.vue'

const robotRef = ref(null)
</script>
